import React from 'react';
import { ClientsView } from '@/components/views/ClientsView';
import AnnouncementBanner from '@/components/layouts/AnnouncementBanner';

export const HomePage = () => {
	return (
		<>
			<AnnouncementBanner />
			<ClientsView />
		</>
	);
};
